<template>
 <div class="row justify-content-center">

    <div id="loaderoverlay" v-bind:style={display:onloader}>
        <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="loaderspinner"></div>
        </div>
    </div>
    <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary shadow border-0">
            <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted my-3">
                    
                    <p class="mt-3">Enter below details to change your password</p>
                </div><hr/>
                <form role="form" @submit.prevent="userdata">                    

                    <base-input class="input-group-alternative" placeholder="New Password" type="password" addon-left-icon="ni ni-lock-circle-open" v-model="newpasswordval">
                    </base-input>

                        <base-input class="input-group-alternative" placeholder="Retype Password" type="password" addon-left-icon="ni ni-lock-circle-open" v-model="retypepasswordval">
                    </base-input>

                    <div class="text-center">
                        <button type="submit" class="my-4 btn btn-primary btn-block">Submit</button>
                    </div>
                </form>
                <div class="text-center pt-2">
                    <router-link to="/login" class="text-primary"><small>Back to Login</small></router-link>
                </div>                        
            </div>
        </div>
    </div>
</div>
</template>

<script>

import swal from 'sweetalert'

export default {
    name: 'changepassword',
    data() {
        return {
            username: '',
            retypepasswordval: '',
            newpasswordval: '',
            errormsg: '',
            onloader: 'none'
        }
    },
   
    methods: {
        userdata: function () {
            let username = this.$store.state.auth.username
            let retypepassword = this.retypepasswordval
            let newpassword = this.newpasswordval
            let accesskey = this.$store.state.auth.accesskey
            let userdata={                   
                    newpassword,
                    username,
                    accesskey}
                    if(retypepassword==newpassword){
                        this.onloader = 'flex'
                        this.$store.dispatch('changepassword', userdata)
                            .then(() => {
                                this.onloader = 'none'
                                this.$router.push('/login');
                                swal({
                                    title: "Success!",
                                    text: "Your password has been change successfuly, you can now login with new password",
                                    icon: "success",
                                    button: "Ok",
                                });
                            })
                            .catch(err => {
                                this.onloader = 'none'
                                swal({
                                    title: "Oops!",
                                    text: err.response.data,
                                    icon: "error",
                                    button: "Ok",
                                });
                            })
                    }else{
                         swal({
                        title: "Oops!",
                        text: "Password Mismatched",
                        icon: "error",
                        button: "Ok",
                    });
                    }
            
        }
    }
}
</script>

<style>
</style>
